import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },
  label: {
    "font-weight": "bold",
    color: "#3c3c3c"
  }
}));
